import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import CoinsIcon from './../../../../assets/icons/Coins.svg?react'
import LinkIcon from './../../../../assets/icons/LinkAlt.svg?react'
import WalletIcon from './../../../../assets/icons/WalletAlt.svg?react'
import ReferralProgramStep from './ReferralProgramStep'

const ReferralProgramSteps = () => {
    return (
        <Grid
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}>
            <Typography variant="h5">Как это работает?</Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '16px',
                    width: '100%',
                    flexDirection: 'column',
                }}>
                <ReferralProgramStep
                    title="1. Поделиться ссылкой"
                    description="Скопируйте вашу персональную реферальную ссылку и отправьте её друзьям"
                    icon={<LinkIcon width={24} height={24} />}
                />
                <ReferralProgramStep
                    title="2. Создать аккаунт и пополнить баланс"
                    description="Пользователю нужно перейти по вашей ссылке, зарегистрироваться и пополнить баланс"
                    icon={<WalletIcon width={24} height={24} color="#ED9121" />}
                />
                <ReferralProgramStep
                    title="3. Получить коины!"
                    description="После того, как пользователь пополнит баланс, вам обоим начисляются бонусные коины"
                    icon={<CoinsIcon width={24} height={24} color="#F86EB3" />}
                />
            </Box>
        </Grid>
    )
}

export default ReferralProgramSteps
